/* SPEC-527 fix loop 4 (Codex read 2, P2): the sidebar alert counts, as a pure rule.
 *
 * A count is `null` when it is NOT KNOWN: the alert read failed (an HTTP 503 or any
 * error). It is never 0 then — 0 means "nothing to act on" and hides the badge. A
 * count read before a failed refresh is dropped too, so an old number never sits
 * beside a failed read. While the first read is still loading the count is 0 (no badge,
 * no claim). */

export interface AlertCounts {
  supplyChain: number | null;
  sales: number | null;
  supplierRisk: number | null;
}

export interface AlertRow {
  alert_type?: string;
  severity?: string;
  alert_count?: number | null;
}

export function deriveAlertCounts(
  alerts: AlertRow[] | null,
  alertsError: string | null,
  supplier: { count?: number | null } | null,
  supplierError: string | null,
): AlertCounts {
  let supplyChain: number | null = 0;
  let sales: number | null = 0;
  if (alertsError) {
    supplyChain = null;
    sales = null;
  } else if (alerts) {
    for (const alert of alerts) {
      const count = alert.alert_count || 0;
      // Supply Chain: only critical stockout risks + expired stock.
      if ((alert.alert_type === 'stockout_risk' && alert.severity === 'critical')
          || alert.alert_type === 'expired_stock') {
        supplyChain += count;
      }
      // Sales: only reactivation targets (high-value dormant 60d+ with 3+ orders).
      if (alert.alert_type === 'reactivation_target') {
        sales += count;
      }
    }
  }
  let supplierRisk: number | null;
  if (supplierError || (supplier && supplier.count === null)) {
    supplierRisk = null;
  } else {
    supplierRisk = supplier?.count || 0;
  }
  return { supplyChain, sales, supplierRisk };
}

/** The sidebar badge text for a count: '?' when not known, nothing for 0. */
export function alertBadgeText(count: number | null): string | null {
  if (count === null) return '?';
  if (count <= 0) return null;
  return count > 99 ? '99+' : String(count);
}
